// src/firebaseConfig.js
const firebaseConfig = {
  apiKey: "AIzaSyA9Q-1b4Cch7Scw6ObAE7xzZdeg3wMfGiA",
  authDomain: "indianflatmates.firebaseapp.com",
  projectId: "indianflatmates",
  storageBucket: "indianflatmates.firebasestorage.app",
  messagingSenderId: "1090775831663",
  appId: "1:1090775831663:web:52681d59c7a8159adea99a",
  measurementId: "G-68PHDND1SZ"
};

export default firebaseConfig;
